<template>
  <div>
    <DataTable
      :value="quotationGrades"
      :paginator="true"
      dataKey="id"
      class="p-datatable-striped p-datatable-sm p-datatable-gridlines p-datatable-customers"
      :rows="50"
      :rowHover="true"
      :selection.sync="selectedQuotationGrades"
      :filters="filters"
      :loading="loading"
      paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
      :rowsPerPageOptions="[25, 50, 100]"
      currentPageReportTemplate="{first} to {last} of {totalRecords} Quotation Grades"
    >
      <template #empty> No Quotation Grades found. </template>
      <template #loading> Loading Quotation Grades data. Please wait. </template>
      <Column selectionMode="multiple" headerStyle="width: 3em;"></Column>
      <Column
        field="id"
        header="id"
        headerStyle="width: 3em"
        :sortable="true"
      >
        <template #body="slotProps">
          <div>
              {{ slotProps.data.id }}
          </div>
        </template>
      </Column>
      <Column
        field="quoteGradeCode"
        header="Quotation Grade Code"
        headerStyle="width: 10em"
        :sortable="true"
      >
        <template #body="slotProps">
          <div>
              {{ slotProps.data.quoteGradeCode }}
          </div>
        </template>
      </Column>
      <Column
        field="quoteGradeName"
        header="Quotation Grade Name"
        headerStyle="width: 10em"
        :sortable="true"
      >
        <template #body="slotProps">
          <div>
              {{ slotProps.data.quoteGradeName }}
          </div>
        </template>
      </Column>
      <Column
        field="active"
        header="Is Active"
        headerStyle="width: 9em"
        :sortable="true"
      >
        <template #body="slotProps">
          <span v-if="slotProps.data.active">YES</span>
          <span v-else>NO</span>
        </template>
      </Column>
      <Column headerStyle="width: 7em;">
        <template #body="slotProps">
          <div
            :style="{position: 'relative'}"
          >
            <SplitButton 
              label="Edit" 
              icon="pi pi-info" 
              class="p-button-success p-mb-2"
              @click="editQuotationGrade(slotProps.data)" 
              :model="getButtons(slotProps.data)"
            >
            </SplitButton>
          </div>
        </template>
      </Column>
    </DataTable>
  </div>
</template>

<script>
import PermissionMixin from '../../PermissionMixin.vue'
export default {
  mixins: [PermissionMixin],
  props: [
    'quotationGrades',
    'loading'
  ],
  data: () => ({
    selectedQuotationGrades: null,
    filters: {
      global: ''
    }
  }),
  created() {
    this.filters.global = this.$route.query.search
  },
  methods: {
    getButtons(data) { 
      this.checkPermissions()
      let buttons = []
      if (this.deleteSettings) {
        buttons.push(
          {
            label: 'Delete',
            icon: 'pi pi-trash',
            command: () => {
              this.deleteQuotationGrade(data)
            }
          }
        )
      }
      return buttons
    },
    deleteQuotationGrade(quotationGrade) {
      this.$emit('delete-quotationGrade', quotationGrade)
    },
    editQuotationGrade(quotationGrade) {
      this.$emit('edit-quotationGrade', quotationGrade)
    }
  }
}
</script>

<style>

</style>